module.exports = __webpack_public_path__ + "h5/img/mfe_20.a5e3b652.jpg";